import defaultTheme from "./clients/defaultTheme";
import ouiTheme from "./clients/ouiTheme";
import investsetTheme from "./clients/investsetTheme";

const Themes = {
  default: defaultTheme,
  "oui-investimentos": ouiTheme,
  investset: investsetTheme,
};

export default Themes;
